var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.563 1.5a2 2 0 0 1 3.874 0H11.5a.499.499 0 1 1 0 1h-1.063a2 2 0 0 1-3.874 0H.5a.499.499 0 1 1 0-1zm-5 5a2 2 0 0 1 3.874 0H11.5a.499.499 0 1 1 0 1H5.437a2 2 0 0 1-3.874 0H.5a.499.499 0 1 1 0-1zM3.5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sortingIcon.11672159f1c100e6cdd04360beb54aff.svg";
export { ForwardRef as ReactComponent };